import { Flex, Spin } from 'antd'

import { Outlet } from '@suntex.core/nav'
import { useOptionalTeamContext } from '@suntex.fim/team'

/**
 * returns JSX for assessment report layout
 */
function AssessmentReportLayout() {
  const isLoading = useOptionalTeamContext()?.isLoading ?? false
  return isLoading ? (
    <Flex
      flex="auto"
      justify="center"
      align="center"
      style={{ height: '100%' }}
    >
      <Spin />
    </Flex>
  ) : (
    <Outlet />
  )
}

export default AssessmentReportLayout
